import * as React from 'react';
import {
  Create,
  SimpleForm,
} from 'react-admin';
import ScientificLiteratureForm from './ScientificLiteratureForm';
import FormToolbar from '../shared/FormToolbar';

const ScientificLiteratureEdit = props => (
  <Create {...props}>
    <SimpleForm
      toolbar={<FormToolbar />}
      redirect="list"
    >
      <ScientificLiteratureForm {...props} />
    </SimpleForm>
  </Create>
);

export default ScientificLiteratureEdit;
